(function () {
    'use strict';

    angular
        .module('app')
        .controller('ContractEditController', ContractEditController);

    ContractEditController.$inject = ['debug', '$stateParams', '$timeout', 'API', 'alert', '$scope', 'i18n', 'helpers',];

    function ContractEditController(debug, $stateParams, $timeout, API, alert, $scope, i18n, helpers) {
        var vm = this;
        vm.id = $stateParams.id;
        vm.isSaving = false;
        vm.save = save;
        vm.contract = {};
        vm.schools = [];
        vm.groups = [];
        vm.contractTypes = [];
        vm.newGroupConnectionGroups = [];
        vm.loadingState = {
            contractIsLoading: false,
            schoolsAreLoading: false,
            connectGroupSchoolsAreLoading: false,
            connectGroupGroupsAreLoading: false
        };

        vm.resourceExpand = 'groups,schools,type';

        vm.isCreatingNewGroupConnection = false;
        vm.newGroupConnectionId = null;
        vm.newGroupConnectionValid = false;

        vm.isCreatingNewSchoolConnection = false;
        vm.newSchoolConnectionId = null;
        vm.newSchoolConnectionValid = false;

        vm.openDisconnectGroupModal = openDisconnectGroupModal;
        vm.openDisconnectSchoolModal = openDisconnectSchoolModal;
        vm.newGroupConnection = newGroupConnection;
        vm.newSchoolConnection = newSchoolConnection;
        vm.saveNewGroupConnection = saveNewGroupConnection;
        vm.saveNewSchoolConnection = saveNewSchoolConnection;

        vm.now = helpers.getDatabaseDatetime();

        activate();

        function activate() {

            $scope.$watch('vm.newSchoolConnectionId', function (newValue, oldValue) {
                if (newValue && newValue !== oldValue && newValue > 0) {
                    var connected = false;
                    vm.schools.forEach(function (element) {
                        if (newValue === element.id) {
                            connected = true;
                        }
                    });
                    if (!connected) {
                        vm.newSchoolConnectionValid = true;
                    }
                } else {
                    vm.newSchoolConnectionValid = false;
                }
            });
            $scope.$watch('vm.newGroupIdSelect', function (newValue, oldValue) {
                if (newValue && newValue !== oldValue && newValue > 0) {
                    var connected = false;
                    vm.contract.groups.forEach(function (element) {
                        if (newValue === element.id) {
                            connected = true;
                        }
                    });
                    if (!connected) {
                        vm.newGroupConnectionValid = true;
                    }
                } else {
                    vm.newGroupConnectionValid = false;
                }
            });

            loadContract();
        }

        function loadContract() {
            vm.loadingState.contractIsLoading = true;
            API.Contract.get({
                id: vm.id,
                expand: vm.resourceExpand
            }).$promise.then(function (response) {
                vm.contract = response;
                vm.schools = response.schools;
                vm.groups = response.groups;
                loadContractTypes();
                vm.loadingState.contractIsLoading = false;
            }, function (response) {
                debug.log(response);
            });
        }

        function loadContractTypes() {
            API.ContractType.get().$promise.then(function (response) {
                vm.contractTypes = response.items;
            }, function (response) {
                debug.log(response);
            });
        }

        function newSchoolConnection() {
            vm.isCreatingNewSchoolConnection = true;
        }

        function newGroupConnection() {
            vm.isCreatingNewGroupConnection = true;
        }

        function saveNewGroupConnection() {
            if (!vm.isSavingNewGroupConnection) {
                vm.isSavingNewGroupConnection = true;
                var promise = API.Contract.connectGroup({
                    id: vm.id,
                    groupId: vm.newGroupIdSelect
                }).$promise;

                promise.then(function (response) {
                    debug.log(response);
                    vm.isSavingNewGroupConnection = false;
                    vm.newGroupConnectionGroups = [];
                    vm.isCreatingNewGroupConnection = false;
                    vm.newGroupConnectionValid = false;
                    window.toast({ message: i18n.get('SAVED'), autoRemoveTime: 5000, type: 'success' });
                    loadContract();
                }, function (response) {
                    debug.error(response);
                    window.toast({ message: i18n.get('FAILED'), type: 'danger' });
                });
            }
        }

        function saveNewSchoolConnection() {
            if (!vm.isSavingNewSchoolConnection) {
                vm.isSavingNewSchoolConnection = true;
                var promise = API.Contract.connectSchool({
                    id: vm.id,
                    schoolId: vm.newSchoolConnectionId
                }).$promise;

                promise.then(function (response) {
                    debug.log(response);
                    vm.isSavingNewSchoolConnection = false;
                    vm.isCreatingNewSchoolConnection = false;
                    vm.newSchoolConnectionId = null;
                    vm.newSchoolConnectionValid = false;
                    window.toast({ message: i18n.get('SAVED'), autoRemoveTime: 5000, type: 'success' });
                    loadContract();
                }, function (response) {
                    debug.error(response);
                    window.toast({ message: i18n.get('FAILED'), type: 'danger' });
                });
            }
        }

        function openDisconnectGroupModal(groupId) {
            var promise = alert.confirm('disconnect-something');
            promise.then(function () {

                var promise = API.Contract.disconnectGroup({
                    id: vm.id,
                    groupId: groupId
                }).$promise;

                promise.then(function () {
                    window.toast({ message: i18n.get('SAVED'), autoRemoveTime: 5000, type: 'success' });
                    loadContract();
                }, function (response) {
                    debug.error(response);
                });
            }, function () {
                debug.log('Closing modal');
            });
        }

        function openDisconnectSchoolModal(schoolId) {
            var promise = alert.confirm('disconnect-something');
            promise.then(function () {

                var promise = API.Contract.disconnectSchool({
                    id: vm.id,
                    schoolId: schoolId
                }).$promise;

                promise.then(function () {
                    loadContract();
                }, function (response) {
                    debug.error(response);
                });
            }, function () {
                debug.log('Closing modal');
            });
        }

        function save() {
            if (!vm.isSaving) {
                vm.isSaving = true;
                var promise = vm.contract.$save({ expand: vm.resourceExpand });
                promise.then(function () {
                    window.toast({ message: i18n.get('SAVED'), autoRemoveTime: 5000, type: 'success' });
                    vm.now = helpers.getDatabaseDatetime();
                }, function (response) {
                    debug.log(response);
                })
                .finally(function() {
                    vm.isSaving = false;
                });
            }
        }
    }
})();